import React, { useState } from 'react';
import {
  Box,
  makeStyles,
  Typography,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import { ReactComponent as PollTickIcon } from '../../img/poll-tick.svg';

const TextPoll = ({
  handleSubmitPoll,
  pollId,
  options,
  showResult,
  disablePollOption,
}) => {
  const classes = useStyles();
  const [hoverIndex, setHoverIndex] = useState(-1);
  return (
    <React.Fragment>
      {options &&
        options.map((option, index) => (
          <Box key={index}>
            <ListItem
              button
              disabled={
                disablePollOption.index === index && disablePollOption.value
              }
              onClick={(e) => handleSubmitPoll(e, pollId, option.id, index)}
              style={{
                cursor: showResult ? 'default' : 'pointer',
                backgroundColor:
                  hoverIndex === index
                    ? showResult
                      ? '#fff'
                      : '#ffecee'
                    : '#fff',
                color: 'inherit',
              }}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(-1)}
              className={classes.listItemStyle}
            >
              <ListItemText
                primary={
                  showResult && (
                    <Typography
                      className={classes.background}
                      style={{
                        width: option.voteResults,
                        backgroundColor: option.isVoted ? '#ffecee' : '#ececec',
                      }}
                    ></Typography>
                  )
                }
                secondary={
                  <Typography
                    className={classes.listItemText}
                    color={'textPrimary'}
                    variant="body2"
                  >
                    {option.description}
                  </Typography>
                }
              />
              {option.isVoted && (
                <PollTickIcon alt="TickIcon" className={classes.tickIcon} />
              )}
            </ListItem>
            {showResult && (
              <Typography className={classes.votesText}>
                {option.voteResults}
              </Typography>
            )}
          </Box>
        ))}
    </React.Fragment>
  );
};
const useStyles = makeStyles((theme) => ({
  listItemStyle: {
    width: '87%',
    display: 'inline-block',
    border: '1px solid #dcdcdc',
    borderRadius: theme.spacing(6),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    position: 'relative',
    overflow: 'hidden',
  },
  listItemText: {
    position: 'relative',
    zIndex: '1',
  },
  votesText: {
    float: 'right',
    marginTop: theme.spacing(2),
  },
  tickIcon: {
    position: 'absolute',
    top: theme.spacing(2.5),
    right: theme.spacing(3),
  },
  background: {
    flex: 'inherit',
    height: '100%',
    position: 'absolute',
    top: theme.spacing(0),
    left: theme.spacing(0),
    borderTopLeftRadius: theme.spacing(6),
    borderBottomLeftRadius: theme.spacing(6),
  },
}));
export default TextPoll;
